<template>
  <div class="service-list-container" v-if="post_url!==''">
    <admin-filter
      ref="adminFilter"
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="서비스 목록"
      desc="개설된 서비스들의 현황을 조회할 수 있습니다."
    ></admin-filter>
    <div class="columns">
      <div class="column is-full">
        <div class="box" style="min-width:1600px;overflow-x:auto">
          <div class="flex-between" style="margin-bottom:12px">
            <div>검색결과 {{ filteredCount }} 개</div>
            <div>
              <select class="input-border" v-model="filtered.page_length" style="width:130px">
                <option v-for="(item,idx) in pageLength" :key="`option-page-len-${idx}`"
                        :value="item.value">{{ item.label }}</option>
              </select>
            </div>
          </div>
          <table>
            <tr>
              <th v-for="(item,idx) in header" :Key="`th-${idx}`" :style="`width:${item[1]}%`">{{ item[0] }}</th>
            </tr>
            <tr v-for="(item,idx) in tableItems" :key="`tr-${idx}`" @click="clickItem(item)">
              <td>{{ item.index }}</td>
              <td>{{ item.service_name }}</td>
              <td>{{ serviceTypeKor[item.service_type] }}</td>
              <td><div v-for="(pack, idx) in item.packages" :key="`pack-${idx}`">{{ packages[pack] }}</div></td>
              <td>
                <a :href="`/office/admin/user/create?id=${item.service_user.id}`" target="_blank" @click.stop>
                  <div>{{ item.service_user.name }}</div></a>
              </td>
              <td>{{ datesFormat(item.contract_date, 'date_3') }}</td>
              <td><template v-if="item.schedule">{{ datesFormat(item.schedule.start_date, 'date_3') }}</template></td>
              <td><template v-if="item.schedule && item.schedule.end_date !== ''">{{ datesFormat(item.schedule.end_date, 'date_3') }}</template></td>
              <td><span :class="`status-${item.status}`">{{ status[item.status] }}</span></td>
              <td><template v-if="item.schedule">{{ item.schedule.price|currency }}</template></td>
              <td><template v-if="item.schedule">{{ datesFormat(item.schedule.next_date, 'date_3') }}</template></td>
              <td><template v-if="item.schedule">{{ item.schedule.date_unit }}개월</template></td>
              <td><template v-if="item.schedule">{{ payType[item.schedule.pay_method] }}</template></td>
              <td class="size-12">
                <template v-if="item.domain && item.domain !== ''">
                  <a :href="item.domain" target="_blank" @click.stop>서비스 바로가기</a><br>
                  <a :href="`${item.domain}/office/admin`" target="_blank" @click.stop>관리자 바로가기</a>
                </template>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <pagination ref="pagination" :total_page="filtered.total_page" @change="onPage"></pagination>
  </div>
</template>
<script>
  import AdminFilter from "../../../module/admin/AdminFilter";
  import AdminTable from "../../../module/admin/AdminTable";
  import ListMixin from "../../../../mixins/ListMixin";
  import Pagination from "../../../module/common/Pagination";
  export default {
    name: "ServiceList",
    components: {
      Pagination,
      AdminTable,
      AdminFilter
    },
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
    },
    data() {
      return {
        header: [
          ['index', 2],
          ['서비스명', 14],
          ['서비스 구분', 10],
          ['서비스팩', 10],
          ['고객 정보', 6],
          ['계약일', 6],
          ['이용\n시작일', 6],
          ['이용\n종료일', 6],
          ['상태', 6],
          ['결제금액', 9],
          ['다음결제일', 5],
          ['결제주기', 5],
          ['결제 방법', 8],
          ['도메인', 15],
        ],
        pageLength: [
          {value: 10, label: '10개씩 보기'},
          {value: 20, label: '20개씩 보기'},
          {value: 30, label: '30개씩 보기'},
          {value: 40, label: '40개씩 보기'},
          {value: 50, label: '50개씩 보기'},
          {value: 100, label: '100개씩 보기'}
        ],
        serviceTypeKor: {
          0: '퀵빌더',
          1: '디자인마켓',
          2: '주문제작',
          3: '솔루션API',
          4: '플랫폼파이',
          5: '스킨',
          6: '독립형'
        },
        payType: {
          0: '빌링결제\n(이니시스)',
          1: '계좌이체',
          2: '빌링결제\n(페이플)',
          3: '충전금 소진'
        },
        status: {
          0: '이용 예정',
          5: '개설 진행 중',
          9: '이용 중',
          10: '관리자 정지',
          99: '전체 정지',
          100: '이용 중단',
          101: '삭제됨'
        },
        packages: {}
      }
    },
    methods: {
      clickItem(item) {
        this.$router.push(this.getPath(`launchpack/service/detail?id=${item.id}`));
      },
      onPage(res) {
        console.log('onPage')
        this.filtered.page_num = res;
        this.getDataFromServer();
      },
      getDataFromServer() {
        this.getData();
      },
      async init() {
        let res = await this.$axios.get('public/service/packages/all');
        res.data.forEach(i=>{
          this.packages[i.key] = i.name;
        });

        let query = this.$route.query.email ?
                    {search_keyword: this.$route.query.email, search_type: 'email', status: 9} : {};
        this.initializing('launchpack_service', 'launchpack/service', query);

        this.$nextTick(()=> {
          if(this.$route.query.email) {
            let adminFilter = this.$refs.adminFilter;
            adminFilter.searchItem.search_keyword = this.$route.query.email
            adminFilter.searchItem.search_type = 'email'
            let input = document.querySelector('.lp-filter-input');
            input.value = this.$route.query.email
            let select = document.querySelector('.lp-filter-select')
            select.value = 'email';
            this.$router.replace(this.$route.path)
          }
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
  $background2=#f5f5f5
  $border-main=#dddddd
  $border-sub=#eeeeee
  $primary=#ff5722

  .service-list-container
    table
      width 100%
      border 1px solid $border-main
      th
      td
        white-space pre-line
        vertical-align middle
        text-align center
        border 1px solid $border-main
        padding 4px 8px
      th
        background-color $background2
      tr:hover
        td
          background-color #ff572210
          cursor pointer

  .status-0
  .status-5
    color #777
  .status-9
  .status-10
    color $primary

  .status-99
  .status-100
    color #a0a0a0
</style>
